
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/strategy/rs3",
      function () {
        return require("private-next-pages/strategy/rs3.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/strategy/rs3"])
      });
    }
  